/* eslint-disable */
export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const CLIENT_ID = 'client_id'
export const CLIENT_SECRET = 'client_secret'
export const GRANT_TYPE = 'grant_type'
export const USERNAME = 'username'
export const PASSWORD = 'password'
export const AUTHORIZATION = 'Authorization'
export const BEARER = 'Bearer '
export const CONTENT_TYPE = 'Content-Type'
export const ACCEPT = 'Accept'
export const CONTENT_TYPE_JSON = 'application/json'
export const CONTENT_TYPE_FORM_DATA = 'multipart/form-data'
export const CONTENT_TYPE_X_WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded'
export const DEFAULT_BAR_CHART_STATUS = 'Application Started'
export const FILE = 'file'
export const DOC = 'doc'
export const FILE_NAME = 'file_name'
export const FILE_TYPE = 'file_type'
export const TYPE = 'document_type'
export const API_URL = {
  GET_ALL_SCHOOLS: '/core/get-schools',
  GET_SCHOOL_BY_SEARCH: '/core/get-schools?q=',
}
export const SUCCESS = 'success'
export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export enum Country {
  UnitedStates = 'united states',
  Canada = 'canada',
}

export const GLOBAL_DEBOUNCE_DELAY = 400
export const GLOBAL_DEBOUNCE_DELAY_700 = 700
export const NOVA_COUNTRYDATA_INFO = [
  {
    countryName: 'india',
    novaInfo: [
      'Use your full name as it appears on your ID or credit report (CIBIL/ CRIF).',
      'Enter your latest Indian phone number and address - even if inactive.',
    ],
    footer: 'Inaccurate information may delay your application.',
  },
  {
    countryName: 'nigeria',
    novaInfo: [
      'Use your full name exactly as shown on your CRC Credit Bureau report.',
      'Enter your Bank Verification Number (BVN) accurately.',
      'Make sure your gender matches with your CRC report.',
    ],
    footer: 'Inaccurate information may delay your application.',
  },
  {
    countryName: 'kenya',
    novaInfo: [
      'Use your full name as it appears on your credit report.',
      'Ensure your gender matches what’s listed on the report.',
    ],
    footer: 'Inaccurate information may delay your application.',
  },
  {
    countryName: 'china',
    footer:
      'If you are not ready to submit your credit report, you may continue with your application.',
    novaInfo: [
      'You will need to upload a recent copy of your Credit Reference Center of the People’s Bank of China (CCRC) report (downloaded within the last 15 days).',
      'You can download a copy of your report through the <a href="https://ipcrs.pbccrc.org.cn/" target="_blank">CCRC website</a> (中国人民银行征信中心) or through your bank’s website or app.',
      'You may need to have access to your Chinese mobile phone number to authenticate your identity and download your report.',
      'It’s important to only submit original PDFs. Copies of PDFs or other file formats will be rejected.',
    ],
  },
]
export const REDIRECT_URL = 'https://www.mpowerfinancing.com/'
export const RESETPASSWORD_OVERTRIED =
  'You have used "Forgot Password" too many times. Please check your email for further instructions and try again later.'
export const RESETPASSWORD_ERROR =
  "We didn't find a user associated with this email address in our records."
export const TOP_UNIVERSITY = [
  {
    id: 'a0w3900000FJcjXAAT',
    name: 'American University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcfZAAT',
    name: 'Arizona State University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcjZAAT',
    name: 'Catholic University of America',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcrLAAT',
    name: 'Clark University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcm6AAD',
    name: 'DePaul University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJd39AAD',
    name: 'Drexel University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcjcAAD',
    name: 'George Washington University - GWU',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcspAAD',
    name: 'Grand Valley State University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcmHAAT',
    name: 'Illinois Institute of Technology',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJct4AAD',
    name: 'Michigan Technological University - MTU',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcwVAAT',
    name: 'Montclair State University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcs4AAD',
    name: 'Northeastern University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcy4AAD',
    name: 'Pace University - New York',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcvKAAT',
    name: 'Saint Louis University-Main Campus',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000HnyMvAAJ',
    name: 'Trent University',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcyVAAT',
    name: 'University at Buffalo',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000HnyN7AAJ',
    name: 'University of Calgary',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcjVAAT',
    name: 'University of Delaware',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000FJcpoAAD',
    name: 'University of Louisville',
    is_enabled: true,
    has_eligible: true,
  },
  {
    id: 'a0w3900000HnyNFAAZ',
    name: 'University of Windsor',
    is_enabled: true,
    has_eligible: true,
  },
]
export const ELIGIBILITY_FORM = {
  heading: 'Let’s start with',
  highlighter: ' the basics.',
  child: [
    {
      isAlignHorizontal: true,
      grandChild: [
        {
          id: 'firstName',
          placeholder: 'Enter your first name',
          label: 'First name',
          type: 'text',
          onPaste: (e: any) => e.preventDefault(),
          maxLength: 40,
          onlyTextAllowed: true,
        },
        {
          id: 'lastName',
          placeholder: 'Enter your last name',
          label: 'Last name',
          type: 'text',
          onPaste: (e: any) => e.preventDefault(),
          maxLength: 40,
          onlyTextAllowed: true,
        },
      ],
    },
    {
      id: 'emailID',
      placeholder: 'Enter your email address',
      label: 'Email address',
      type: 'email',
      onPaste: (e: any) => e.preventDefault(),
      maxLength: 70,
    },
  ],
  ELIGIBILITY_FORM: {
    heading: 'Let’s start with',
    highlighter: ' the basics.',
    child: [
      {
        isAlignHorizontal: true,
        grandChild: [
          {
            id: 'firstName',
            placeholder: 'Enter your first name',
            label: 'First Name',
            type: 'text',
            onPaste: (e: any) => e.preventDefault(),
            maxLength: 40,
            onlyTextAllowed: true,
          },
          {
            id: 'lastName',
            placeholder: 'Enter your last name',
            label: 'Last Name',
            type: 'text',
            onPaste: (e: any) => e.preventDefault(),
            maxLength: 40,
            onlyTextAllowed: true,
          },
        ],
      },
      {
        id: 'emailID',
        placeholder: 'Enter your email address',
        label: 'Email Address',
        type: 'email',
        onPaste: (e: any) => e.preventDefault(),
        maxLength: 70,
      },
    ],
  },
  ELIGIBILITY_HEADING_H1: 'Check your',
  ELIGIBILITY_HEADING_YELLOW_H1: 'loan eligibility',
  ELIGIBILITY_HEADING_H2: ' in',
  ELIGIBILITY_SUBHEADING: 'in just 1 minute!',
  ELIGIBILITY_TIP:
    'If you have multiple first or last names, enter them as they appear on your passport, <b>US driver’s license</b>, or other legal documents. If you have a middle name, add it to the first name field.',
  FIELDERROR:
    'Something went wrong !!. There is some issue over this page , Kindly revalidate the entered data and proceed.',
  errorMessageList: {
    findSchoolName: 'Enter a valid state or province',
  },
  placeholderText: {
    gpaDisable: "The GPA field is disabled because you indicated you haven't received a GPA yet.",
    gpaEnabled: 'Your GPA (0.01 - 4.00)',
  },
}
export const COSIGNER_PAGE_INFO = {
  LEFT_HEADING: {
    nameHeadingYellow: 'We’re sorry',
    subHeadingBlue: 'You’re not currently eligible for an MPOWER loan.',
  },
  RIGHT_HEADING: {
    headingBlue: 'But don’t worry, we might have other options for you.',
  },
  questionList: [
    {
      question: 'Do you have a co-signer that is a US citizen or a permanent resident of US?',
      options: [
        { text: 'NO', showOutlineButton: true, showFilledButton: false, value: false },
        { text: 'YES', showOutlineButton: false, showFilledButton: true, value: true },
      ],
    },
  ],
}
export const ELIGIBILITY_WAITLIST_MESSAGE = 'Join our'
export const ELIGIBILITY_WAITLIST_MESSAGE_YELLOW = 'Waitlist!'
export const ELIGIBILITY_HEADING_H1 = 'Check your'
export const ELIGIBILITY_HEADING_YELLOW_H1 = 'loan eligibility'
export const ELIGIBILITY_HEADING_H2 = ' in'
export const ELIGIBILITY_SUBHEADING = 'in just 1 minute!!'
export const ELIGIBILITY_TIP =
  'If you have multiple first or last names, enter them as they appear on your passport, <b>US driver’s license</b>, or other legal documents. If you have a middle name, add it to the first name field.'
export const APISUCCESS = 'success'
export const FIELDERROR =
  'Something went wrong !!. There is some issue over this page , Kindly revalidate the entered data and proceed.'
export const ERROR_MESSAGE_LIST = {
  findSchoolName: 'Enter a valid state or province',
}
export const PLACEHOLDER_TEXT = {
  gpaDisable: "The GPA field is disabled because you indicated you haven't received a GPA yet.",
  gpaEnabled: 'Your GPA (0.01 - 4.00)',
}
export const INVALIDSELECTION = 'invalidSelection'
export const ADMISSIONPARTNER = 'Admission Partner'
export const UPLOAD_ADMISSION_LETTER = 'Proof of Program of study'
export const UPLOAD_TUITION_BILL = 'Tuition Bill'
export const UPLOAD_NOC = 'NOC Document'
export const SOMETHING_WENT_WRONG = 'Something went wrong! Please try again later.'
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please sign in again.'
export const ACTIVECOAVERSION = 'a'
export const LS_URL_RESTRICTION = [
  {
    flagMap: {
      parent: ['compLightSegIneligible'],
      child: ['lightSegIneligible'],
    },
    restrictedModule: ['education', 'employment'],
    redirectToRoute: '/education',
  },
]
export const TAS_USER = 'tas_user'
export const LIGHT_SPEED_SEGMENTS = ['LS_Category_1', 'LS_US_GRAD']
export const INELIGIBILE_MESSAGE =
  'If you want to try for a different school, you can restart your application now.'
export const US_GRAD_WAITLIST_MESSAGE =
  "You're Eligible and Added to the Priority Waitlist\n\nThanks for checking your eligibility. You'll be among the first contacted when it's time to apply."
export const IN_SCHOOL_WAITLIST_MESSAGE =
  "You don't currently meet our loan eligibility criteria.\n\nWe've added you to our waitlist and will notify you if there are any eligibility updates."
export const IN_SCHOOL_WAITLIST_MESSAGE_TEMP =
  "We have reached our current funding capacity and are temporarily unable to offer new loans for 2026.\n\nIf you would like to be added to a waitlist for future funding consideration, we will notify you of any updates."
export const CANADA_RB_WAITLIST_MESSAGE_PREFIX =
  'We have reached our current funding capacity and are temporarily unable to offer new loans for 2026. If you would like to be added to a waitlist for future funding consideration, we will notify you of any updates.'
export const CANADA_RB_WAITLIST_CTA_TEXT = 'Join waitlist'
export const CANADA_RB_WAITLIST_JOINED_MESSAGE =
  "You've been added to the waitlist. We'll reach out when our Canada lending program reopens."
export const RB_UNAVAILABLE_HEADING = 'Additional loan applications are temporarily unavailable for 2026'
export const RB_UNAVAILABLE_BODY =
  'We have reached our current funding capacity and are temporarily unable to accept applications for additional loans for 2026. This does not affect your existing loans or applications you have already submitted.'
export const RB_UNAVAILABLE_QUERY_PARAM = 'rbUnavailable'

export const PAGE_ERROR_TIMER = 3000
export const SWW = 'Something went wrong'
export const HIDE_FUNDING_FIELD = ['Scholarships and grants']
export const IMMIGRATION_NOT_VALID_FOR_VISA = ['Citizen', 'Permanent resident', 'DACA']
export const HOME_REDIRECT_URL = 'https://www.mpowerfinancing.com/'
export const RESET_MAIL_SEND_DATA = {
  HEADING: 'It looks like you already have an account with us.',
  SUBHEADING: "We've sent a reset link to ",
  INFO: 'Please check your inbox to proceed.',
  OLDINFO: 'We sent a reset link to your email.',
  OLDSUBHEADING:
    "Check your spam folder if you can't find it. Using Gmail? Check your promotions tab as well.",
}
export const RESET_MAIL_SEND_SUBHEADING =
  "Check your spam folder or promotions tab if you can't find it."
export const MYPROFILE_CONSENT_MESSAGES = {
  PARTNER: {
    header: 'Do you consent to share your information with the MPOWER partner?',
    subHeader:
      'Our partners may send promotional emails about products and services to help your study abroad experience.',
  },
  REFERRER: {
    header: 'Do you consent to share your information with the MPOWER referrer?',
    subHeader:
      'By opting in, the referrer will only be able to view your name to track the status of their referral reward.',
  },
}

export const REFERRER = 'referrer'
export const PROMOCODE_HEADERS = {
  REGULARFLOW_TITLES: {
    blueHeader: 'Please enter in your',
    yellowHeader: 'promo code',
  },
  PARTNERFLOW_TITLES: {
    blueHeader: 'Do you have a',
    yellowHeader: 'promo code?',
  },
}
export const ACADEMIC_TERM_ERROR =
  'Our limit for a single semester loan is $50K. If you are requesting more than that, you should select a full academic year'
export const AY_MAX_LIMIT = 99500
export const AY_MIN_LIMIT = 2000
export const AY_SLIDE_HIDE_AMOUNT = 99400
export const REQUEST_MAX_LIMIT = 100000
export const PENDING_REVIEW = 'pending review'
export const POTENTIAL_DECISION = 'Potential Decision'
export const POTENTIAL_NO_DECISION = 'Potential No-Decision'
export const POTENTIAL_CONDITION_OFFER = 'Potential Conditional Offer'
export const TOTAL_AMOUNT_REQUESTED_LABEL = 'Total amount requested'
export const SPRING_AND_FALL_2024 = 'Spring 2024 & Fall 2024'
export const TOTAL_AMOUNT_REQUESTED_LABEL_CANADA =
  'Total amount requested (Your requested loan amount should only include tuition and fees.)'
export const AY_SEMESTER_LIMIT = 50000
export const PARTIAL_OFFER = 'Partial'
export const REQUESTED_LOAN_AMOUNT_TEXT = {
  US: "Enter the loan amount you'd like to request here. This can include tuition, living expenses, books and supplies (such as a laptop) and travel expenses. ",
  CANADA:
    "Enter the loan amount you'd like to request here. Use your funding gap as a starting point.",
}
export const US_WISCONSIN = 'Wisconsin'
export const POBOX_COUNTRIES = [
  'nigeria',
  'liberia',
  'kenya',
  'ethiopia',
  'ghana',
  'uganda',
  'sierra leone',
  'rwanda',
  'zimbabwe',
]
export const ELIGIBILITY_CONFIRM_HEADING = {
  CANADA:
    'By clicking "Agree and Continue" , I hereby consent to receive emails and telephone communication from MPOWER concerning my loan application and related services, and acknowledge that I have read and agree to the Privacy Policy.',
  CANADAELECTTRONICHEADING:
    'By clicking "Agree and Continue" I hereby consent to receiving commercial electronic messages from MPOWER for marketing and other promotion of its services. I understand that I can revoke my consent to receiving commercial electronic messages at any time by visiting the following website www.mpowerfinancing.com, clicking the "unsubscribe" link at the bottom of email communication from MPOWER, or texting STOP in reply to a text message from MPOWER.',
  US: 'By clicking "Agree and Continue" , I hereby consent to receive emails from MPOWER and acknowledge that I have read and agree to the Privacy Policy.',
}
export const SERVICEABLE_COUNTRY = {
  US: 'united states',
  CANADA: 'canada',
}

export const ACCEPT_DISCLOSURE = {
  LENDINGACT: {
    CANADA: {
      placeholder: 'I acknowledge the receipt of the ',
      linkPlaceholder: 'Important Terms. ',
    },
    US: {
      placeholder: 'I have read and agree to the ',
      linkPlaceholder: 'Truth in Lending Act Application Disclosures.',
    },
    REDIRECT_LINK: '/finance/lendingAct',
  },
  CREDITPULL: {
    CANADA: {
      placeholder: 'I have read and agreed to the ',
      linkPlaceholder: 'Credit pull consent. ',
    },
    US: {
      placeholder: 'I have read and agree to the ',
      linkPlaceholder: 'Credit Report Authorization',
      linkMilitaryPlaceholder: 'Military Lending Act Disclosures.',
    },
    REDIRECT_CREDIT_LINK: '/finance/creditDisclosure',
    REDIRECT_MILITARY_LINK: '/finance/mlaDoc',
  },
  REFERRAL: {
    placeholder: 'By checking this box, you agree to the ',
    linkPlaceholder: 'MPOWER Referral Program Terms and Conditions',
    REDIRECT_LINK: '/finance/referral-policy',
  },
}

export const COOKIELIST_ELIGIBILITY = ['eligibilityData', 'tempOppId']
export const UTMCOOKIE_LIST = ['utmParams']
export const COOKIELIST_ELIGIBILITY_ROUTE = ['eligibilityData', 'tempOppId', 'partnerCookie']
export const SSO_LOGIN_LIST = [{ ssoLoginImg: 'gSignIn', ssoLoginName: 'Google/Gmail' }]
export const USER_ROLE = {
  borrower: 'BORROWER',
  borrowerUSGrad: 'BORROWER-US-GRAD',
  borrowerInSchoolUSSchool: 'BORROWER-IN-SCHOOL-US',
  borrowerInSchoolCanSchool: 'BORROWER-IN-SCHOOL-CAN',
  borrowerRefi: 'BORROWER-REFI',
  borrowerInSchool: 'BORROWER-IN-SCHOOL',
  preBorrower: 'PRE-BORROWER',
  preBorrowerRefi: 'PRE-BORROWER-REFI',
  preBorrowerInSchool: 'PRE-BORROWER-IN-SCHOOL',
  tas: 'TAS',
}

export const LOGIN_TYPE = {
  social: 'social',
  self: 'self',
}

export const NOTIFICATION_DEFAULT_VALUE = {
  withCloseButton: false,
  withBorder: true,
  icon: null,
  color: '#FFF3BD',
  progressBarColor: '#FFAF0F',
  progressBarDuration: 3000,
  title: 'Your password was reset.',
}
export const TRUSTPILOT_SRC =
  'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
export const TRUSTPILOT_DATA_TEMPLATE_ID = '53aa8807dec7e10d38f59f32'
export const TRUSTPILOT_DATA_BUSINESS_ID = '5c7eff86b62d9a000147b23b'
export const SCHEDULED_APPOINTMENT = 'I have an appointment scheduled'
export const PARENT = 'Parent'
export const RELATIVE = 'Relative'
export const MY_PROFILE_PHONE_FIELD = [
  {
    id: 'phone_number',
    label: 'Mobile',
    state: 'phone',
    subType: 'primary',
    isVerificationRequired: false,
    gridSize: 6,
    type: 'phone',
  },
  {
    id: 'email',
    label: 'Email',
    state: 'email',
    subType: 'primary',
    isVerificationRequired: false,
    gridSize: 6,
    placeHolder: 'Enter email address',
    readOnly: true,
    type: 'email',
  },

  {
    id: 'school_country_phone_number',
    label: 'School Country Mobile',
    state: 'schoolPhone',
    subType: 'school',
    isVerificationRequired: false,
    gridSize: 6,
    type: 'phone',
  },
  {
    id: 'school_email_number',
    label: 'School Associated Email',
    state: 'emailschool',
    subType: 'school',
    isVerificationRequired: false,
    gridSize: 6,
    placeHolder: 'Enter email address',
    readOnly: true,
    type: 'email',
  },
  {
    id: 'alternative_phone_number',
    label: 'Alternative Mobile',
    state: 'alternativePhone',
    subType: 'alternate',
    isVerificationRequired: false,
    gridSize: 12,
    type: 'phone',
  },
  {
    id: 'alternative_email',
    label: 'Alternative Email',
    state: 'emailalternate',
    subType: 'alternate',
    isVerificationRequired: false,
    gridSize: 6,
    placeHolder: 'Enter email address',
    readOnly: true,
    type: 'email',
  },
]

export const FUNDING_TYPE = {
  DEBT: 'debt',
  LOAN: 'loan',
}

export const DOC_UPLOAD_INFOMESSAGE =
  "Please upload a JPG, PNG, GIF, PDF, DOC, or DOCX file under 5MB. Click the info icon 'i' for details."
export const DOC_UPLOAD_INFOMESSAGE_KICKBACK =
  'Please upload a JPG, PNG, GIF, PDF, DOC, or DOCX file under 5MB.'

export const REFERENCE = 'reference'

export const ALL_COOKIE_LIST = [
  'eligibilityData',
  'mpowerReferrer',
  'deferData',
  'cancelLoanData',
  'contactId',
  'disbursementList',
  'existingUser',
  'finalSubmitData',
  'holdLoanData',
  'isDashboardRouted',
  'laravelSession',
  'loginPassChange',
  'novaTried',
  'opportunityId',
  'partnerCookie',
  'returnToCookie',
  'tempIdCookie',
  'tempOppId',
  'usDt',
  'userId',
  'code',
  'lightSpeedFinanceFlow',
  'sfmc',
  'userFromEmailNotification',
  'hdyhauABTest',
  'isSSOUser',
  'userDataForTracking',
  'eligibilityFromSSO',
]

export const logoutCookieToClearWithDomain = [
  'loginPassChange',
  'existingUser',
  'eligibilityData',
  'opportunityId',
  'tempOppId',
  'borrowerStepProgress',
  'contactId',
  'partnerCookie',
  'userDataForTracking',
  'tempIdCookie',
  'loginPassChange_refi',
  'existingUser_refi',
  'eligibilityData_refi',
  'opportunityId_refi',
  'tempOppId_refi',
  'borrowerStepProgress_refi',
  'contactId_refi',
  'partnerCookie_refi',
  'userDataForTracking_refi',
  'tempIdCookie_refi',
]
export const sessionCheckRoutes = ['/eligibility']

export const REACT_APP_PUBLIC_POSTHOG_KEY = 'phc_4Qdr1dwJVzr6YeHePQRlx9ZMavX3kHUsurdNY8sHSMs'
export const REACT_APP_PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com'
export const DISBURSEMENT_STATUS_MESSAGES: Record<
  'full' | 'limited' | 'tuition',
  { header: string; subHeader: string; reqLoanPageText: string }
> = {
  full: {
    header:
      'Includes tuition fees, books and supplies, health insurance costs and living expenses based on school policy.',
    subHeader:
      'We provide funding for health insurance, tuition fees, books and supplies and living expenses based on school policy.',
    reqLoanPageText:
      'This should include tuition fees, books and supplies, health insurance costs and living expenses based on school policy.',
  },
  limited: {
    header:
      'Includes tuition fees, books and supplies, health insurance costs and living expenses based on school policy.',
    subHeader:
      'We provide funding for health insurance, tuition fees, books and supplies and living expenses based on school policy.',
    reqLoanPageText:
      'This should include tuition fees, books and supplies, health insurance costs and living expenses based on school policy.',
  },
  tuition: {
    header:
      'Includes tuition fees, books and supplies, and health insurance costs as mentioned in the school tuition invoice.',
    subHeader:
      'We provide funding for health insurance, tuition fees, books and supplies as mentioned in the school tuition invoice.',
    reqLoanPageText:
      'This should include tuition fees, books and supplies, and health insurance costs as mentioned in the school tuition invoice.',
  },
}
export const franklinBasedAddOnMajors = [
  { id: 'a1Rf2000001DM4iEAR', name: 'MILES - Health Informatics' },
]
export const majorDecidingSchool = 'Franklin University'

export const deviceTypeConfig = {
  isMobileSize: '(max-width: 480px)',
  isTabletSize: '(max-width: 768px)',
  isDesktopSize: '(max-width: 1200px)',
}
export const MAXIMUM_RETRY_SSO = "We're getting a lot of requests right now. Please try again soon."

export const UTM_SOURCE_ATTRIBUTION_TYPES = {
  SOURCE_URL: 'source url',
  UTM_SOURCE: 'utm source',
  NULL: null,
}

export const FIELD_MAPPING = {
  email: 'email',
  primary: 'primary',
  alternate: 'alternate',
  phone: 'phone',
  social: 'social',
  linkedin: 'linkedin',
  permanent: 'permanent',
  current: 'current',
  reference: 'reference',
  mailing: 'mailing',
}

export const HARDSHIP_PAGE_STEPPER = [
  {
    label: 'Verification',
  },
  {
    label: 'Borrower Details',
  },
  {
    label: 'Final Review',
  },
  {
    label: 'Confirm and Submit',
  },
]
export const HARSHIP_TEMPLATE_MAPPING = {
  CBPO: 'Credit Building Payment Option (CBPO)',
  RIO: 'Return to Interest Only Option (RIO)',
  FORBEARANCE: 'Forbearance Agreement Option',
  OTHER: 'Other',
}

export const EMPLOYMENT_STATUS_OPTIONS = [
  'Part Time Employed',
  'Full Time Employed',
  'Unemployed',
  'Studying',
]
export const HARDSHIP_BORROWER_DETAIL_FIELDS_CONFIG = [
  {
    id: 'grad_date',
    label: 'Graduation Date*',
    component: 'CustomCalender',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'employment_status',
    label: 'Employment Status*',
    component: 'SelectDropdown',
    options: EMPLOYMENT_STATUS_OPTIONS,
    span: 6,
    mobileSpan: 12,
    customClass: 'fieldCustomStyles',
  },
  {
    id: 'income',
    label: 'Current annual income (in USD)*',
    component: 'TextField',
    type: 'number',
    placeholder: 'Enter Income in US$',
    maxLength: 80,
    span: 6,
    mobileSpan: 12,
    customClass: 'textFieldCustomStyles',
  },
  {
    id: 'reason',
    label: 'Reason for requesting CBPO*',
    component: 'TextArea',
    placeholder: 'Enter reason within 100 characters',
    maxLength: 100,
    span: 12,
    mobileSpan: 12,
    customClass: 'fieldCustomStyles',
  },
  {
    id: 'plan_to_pay_after_cbpo',
    label: 'How do you plan to repay after CBPO*',
    component: 'TextArea',
    placeholder: 'Explain within 100 characters',
    maxLength: 100,
    span: 12,
    mobileSpan: 12,
    customClass: 'fieldCustomStyles',
  },
]
export const MONTHLY_EXPENSE_FIELDS = [
  {
    id: 'exp_housing',
    label: 'Housing (mortgage or rent)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_transport',
    label: 'Transportation (gas or metro pass)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_insurance',
    label: 'Insurance (car or health)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_utilities',
    label: 'Utilities (phone, electricity, water, heat)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_debt_auto',
    label: 'Debt (auto loans)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_debt_cc',
    label: 'Debt (credit cards)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_debt_personal',
    label: 'Debt (personal loans)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_debt_other_student',
    label: 'Debt (other student loans)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_family_support',
    label: 'Family support (money sent back home)*',
    placeholder: 'Enter expense in US$',
  },
  {
    id: 'exp_total',
    label: 'Total Monthly expenses*',
    placeholder: 'Enter expense in US$',
  },
]
export const MONTHLY_INCOME_FIELDS = [
  {
    id: 'inc_employment',
    label: 'Employment (salary, commission)*',
    placeholder: 'Enter amount in US$',
  },
  { id: 'inc_savings', label: 'Personal savings*', placeholder: 'Enter amount in US$' },
  { id: 'inc_family_support', label: 'Family support*', placeholder: 'Enter amount in US$' },
  {
    id: 'investmentIncome',
    label: 'Other income (investments, inheritance, royalties, etc.)*',
    placeholder: 'Enter amount in US$',
  },
  { id: 'inc_other', label: 'Other source of funds*', placeholder: 'Enter amount in US$' },
  { id: 'inc_total', label: 'Total Income*', placeholder: 'Enter amount in US$' },
]

export const COMMMAND_TYPE = {
  VALIDATE_OTP: 'validate_otp',
  COMPLETED: 'completed',
}
export const ERROR_MESSAGE = {
  PHONE_NUMBER: 'Please enter a valid phone number',
}

export const HARDSHIP_CONTACT_TYPE = [
  {
    label: 'Email',
    value: 'Email',
    icon: 'emailIc',
  },
  {
    label: 'Phone',
    value: 'Phone',
    icon: 'phoneIc',
  },
  {
    label: 'Whatsapp',
    value: 'Whatsapp',
    icon: 'watsappIc',
  },
]
export const permanentFields = [
  {
    id: 'address',
    label: 'Address line 1*',
    placeholder: 'Enter your street address',
    component: 'TextField',
    maxLength: 80,
    customClass: 'textFieldCustomStyles',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'addressLine2',
    label: 'Address line 2',
    placeholder: 'Unit or apartment number',
    optional: true,
    component: 'TextField',
    customClass: 'textFieldCustomStyles',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'city',
    label: 'City*',
    placeholder: 'Enter your city',
    component: 'TextField',
    customClass: 'textFieldCustomStyles',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'country',
    label: 'Country*',
    placeholder: 'Enter your country',
    component: 'PermanentCountry',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'state',
    label: 'State or Province*',
    component: 'PermanentProvinceState',
    span: 6,
    mobileSpan: 12,
  },
  {
    id: 'zipcode',
    label: 'Zip/Postal Code',
    placeholder: 'Enter zip code',
    component: 'TextField',
    customClass: 'textFieldCustomStyles',
    span: 6,
    mobileSpan: 12,
  },
]
export const FORBEARANCE = 'forbearance'
export const OTPTYPE = {
  WHATSAPP: 'whatsapp',
  PHONE: 'phone',
  SMS: 'sms',
}
export const PHONECOUNTRY = {
  US: 'US',
}
export const CHINA_PHONE_DATA = {
  value: '🇨🇳 - +86',
  label: '🇨🇳 - +86',
  key: 'CN',
  code: '86',
  emoji: '🇨🇳',
  name: 'China',
  codeWithPlus: '+86',
  codeWithZero: '086',
  codeWithZeroWithPlus: '+086',
  valueWithName: '🇨🇳 - China (+86)',
}
export const NOVADECLINE = 'Borrower credit declined'
export const NOVA_CREDIT_UTIL_CONSTANT = {
  MAX_RETRIES: 3,
  RETRY_INTERVAL: 3000,
}
export const TRANSIENT_STATUS = ['application under review']
export const REVALIDATOR_CONFIG = {
  INTERVAL: 5000,
  STATUS: {
    IDLE: 'idle',
    VISIBLE: 'visible',
    LOADING: 'loading',
  },
  MAX_RETRIES: 7,
}

export const REVIEW_MESSAGE = [
  'Please stay on this page while we complete a quick review.',
  'We’re finalizing this step before you continue with your application.',
  'Almost there — just finishing a quick check.',
]
export const REDIRECTION_TYPE = {
  BORROWER_REFI_TYPE: 'borrowerRefiType',
  IS_BORROWER_STEP_ELIGIBLE: 'Eligible',
}
export const commonLoginError =
  'The email and/or password you entered is incorrect. Try again or reset your password.'
export const mpowerReferrerUrl = 'https://www.mpowerfinancing.com/'
export const juneFailureReason = 'Application_Stop_Jun26'
